export const UNCATEGORIZED = 'uncategorized';

export const PREDICTION_CATEGORIES = [
  'sports',
  'crypto',
  'politics',
  'elections',
  'economics',
  'financials',
  'entertainment',
  'climate_weather',
  'mentions',
  'other',
  UNCATEGORIZED
] as const;

export type PredictionCategory = (typeof PREDICTION_CATEGORIES)[number];

export const CATEGORY_LABELS: Record<PredictionCategory, string> = {
  sports: 'Sports',
  crypto: 'Crypto',
  politics: 'Politics',
  elections: 'Elections',
  economics: 'Economics',
  financials: 'Financials',
  entertainment: 'Entertainment',
  climate_weather: 'Climate & Weather',
  mentions: 'Mentions',
  other: 'Other',
  [UNCATEGORIZED]: 'Uncategorized'
};
